export default "__VITE_PUBLIC_ASSET__3ae46451__"